import { render, staticRenderFns } from "./PatientOrthoDiagnoseDetail.vue?vue&type=template&id=4da68f2f&"
import script from "./PatientOrthoDiagnoseDetail.vue?vue&type=script&lang=js&"
export * from "./PatientOrthoDiagnoseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports